module.exports = __webpack_public_path__ + "img/744.5dd3f8c5.jpg";